import { Divider, Flex, Paper, Text, Tooltip, rem } from "@mantine/core";
import { upperFirst } from "@mantine/hooks";
import { useMemo } from "react";
import styles from "../../styles/elements.module.css";
import { PropertyTabType } from "../../types";
import { getRandomColor } from "../../utils/colors";
import { formatNumberWithCommas } from "../../utils/numbers";

export default function PropertyTab({
  propertyName,
  numOfMeters,
  totalConsumption,
  activeTab,
  handlePropertySelect,
  id,
}: PropertyTabType & {
  handlePropertySelect: (propertyId: string) => void;
}) {
  const backgroundColor = useMemo(() => getRandomColor(), []);

  return (
    <Paper
      radius={"md"}
      p="md"
      h={rem(140)}
      w={rem(150)}
      bg={backgroundColor}
      className={styles["property-tab"]}
      onClick={() => {
        handlePropertySelect(id);
      }}
    >
      <Flex direction={"column"} justify={"flex-end"} h={"100%"}>
        <Tooltip label={propertyName}>
          <Text c={"white"} size="lg" fw={600} lineClamp={1}>
            {upperFirst(propertyName)}
          </Text>
        </Tooltip>
        <Text fw={600} c={"white"} size="sm">
          {numOfMeters} smart meter{numOfMeters === 1 ? "" : "s"}
        </Text>
        <Text fs={"italic"} c={"white"} size="sm" fw={400}>
          Total consumption
        </Text>
        <Text fs={"italic"} fw={600} c={"white"} size="12px">
          {formatNumberWithCommas(totalConsumption)} liters
        </Text>
        <Divider
          w={"100%"}
          size="xl"
          style={{
            visibility: activeTab ? "visible" : "hidden",
            borderRadius: "4px",
            borderColor: "white",
          }}
          mt={7}
        />
      </Flex>
    </Paper>
  );
}
